import PropTypes from 'prop-types'
import React from 'react'

import Copyright from './Copyright'
import Wrapper from './Wrapper'

const Footer = ({ copyright }) => (
  <Wrapper>
    <Copyright>{copyright}</Copyright>
  </Wrapper>
)

Footer.propTypes = {
  copyright: PropTypes.string,
}

Footer.defaultPropt = {
  copyright: `Copyright`,
}

export default Footer



// WEBPACK FOOTER //
// ./src/containers/Layout/Footer/Footer.js